// BETS == ODDS, NO MODELO DEFINIDO POR SANDRO ESTA BETS, PORTANTO PRA NAO MUDAR O PADRAO MANTIVE A MESMA NOMECLATURA

import { CrudStatus, IBet, IBetSettlement, IBetStatus } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from 'fwork-jsts-common/src/apiClient'
import { FormItemStyled, FormStyled } from 'fwork.react.apptemplate'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import axios from "../../apiClient/axios"
import { BetsApiClient } from "../../apiClient/bets"
import { DEFAULTGAP } from '../../globals'
import { HeaderComponent } from '../common/header'
import { EventBetComponent } from "./eventBet"
import { SearchInputComponent } from "../common/searchInput"
import { BetsStatusApiClient } from "../../apiClient/betsStatus"
import { BetsSettlementsApiClient } from "../../apiClient/betsSettlements"

export interface EventBetsComponentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  eventId: number,
  data?: IBet[],
  onLoadData?: (data?: IBet[]) => void,
  onChangeItem?: (bet: IBet) => void,
}

export const EventBetsComponent = (props: EventBetsComponentProps) => {
  const { eventId, data, onLoadData, onChangeItem, ...rest } = props
  const { enqueueSnackbar } = useSnackbar()

  const [stateData, setStateData] = useState<{
    // data: IBet[],
    filteredData: IBet[]
  }>({
    // data: data ?? [],
    filteredData: data ?? []
  })

  const [filter, setFilter] = useState('')
  const [betStatusList, setBetStatusList] = useState<IBetStatus[]>([])
  const [betSettlementList, setBetSettlementList] = useState<IBetSettlement[]>([])

  const [gettingData, setGettingData] = useState<boolean>()
  const getData = async (eventId: number) => {
    if (gettingData) return;
    setGettingData(true)

    try {
      const response = await new BetsApiClient(axios).get({
        where: {
          event_id: eventId
        },
        nested: 'market,status,settlement',
        // sort: { 'market.name': 1 }
        sort: { 'market_id': 1, 'key_tag': 1 }
      })

      setStateData({
        // data: response.data?.payload ?? [],
        filteredData: getFilteredData(response.data?.payload ?? [], filter)
      })

      if (onLoadData)
        onLoadData(response.data?.payload)
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingData(false)
    }
  }

  const [gettingBetStatusList, setGettingBetStatusList] = useState<boolean>()
  const getBetStatusList = async () => {
    if (gettingBetStatusList) return;
    setGettingBetStatusList(true)

    try {
      const response = await new BetsStatusApiClient(axios).get({
        sort: { name: 1 }
      })

      setBetStatusList(response.data?.payload ?? [])
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingBetStatusList(false)
    }
  }

  const [gettingBetSettlementList, setGettingBetSettlementList] = useState<boolean>()
  const getBetSettlementList = async () => {
    if (gettingBetSettlementList) return;
    setGettingBetSettlementList(true)

    try {
      const response = await new BetsSettlementsApiClient(axios).get({
        sort: { name: 1 }
      })

      setBetSettlementList(response.data?.payload ?? [])
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingBetSettlementList(false)
    }
  }

  const getFilteredData = (data: IBet[], filter: string) => {
    return data.filter(i => i.name.toUpperCase().indexOf(filter.toUpperCase()) != -1 || i.market?.name.toUpperCase().indexOf(filter.toUpperCase()) != -1)
  }

  const filterData = (filter: string) => {
    setStateData(prev => ({
      // ...prev,
      filteredData: getFilteredData(data ?? [], filter)
    }))
  }

  useEffect(() => {
    getBetStatusList()
    getBetSettlementList()
  }, [])

  return <div {...rest} aria-label="EventBetsComponent">
    <FormStyled fullWidth>
      <FormItemStyled gap={DEFAULTGAP} fullWidth>
        <HeaderComponent
          title={<SearchInputComponent
            style={{
              width: 'calc(100% - 80px)'
            }}
            label='Pesquisar por odd ou grupo de odd'
            onChange={(e => {
              setFilter(e.target.value.trim())
              filterData(e.target.value.trim())
            })}
            onKeyUp={undefined}
            onIconClick={undefined}
          />}
          onRefreshClick={() => {
            getData(props.eventId)
          }}
        />
      </FormItemStyled>
    </FormStyled>

    <FormStyled gap={DEFAULTGAP} fullWidth style={{ alignItems: 'flex-start' }}>
      {stateData.filteredData.map((bet, idx) =>
        <EventBetComponent key={idx}
          bet={bet}
          prior={stateData.filteredData[idx - 1]}
          betStatusList={betStatusList}
          settlementList={betSettlementList}
          onChangeData={onChangeItem}
        />
      )}
    </FormStyled>
  </div>
}